import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../services/auth.service";
import TokenService from "../services/token.service";
import { RESET } from "../types";
import { removeIFoodWidget } from "../../utils/window";
import { disconnectSocket } from "../../api/socketService";

const initialState = {
  user: null,
  isLoggedIn: null,
  error: null,
  loading: false,
};

// Async Thunks
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async ({ username, first_name, last_name, email, password }) => {
    const response = await AuthService.register(
      username,
      first_name,
      last_name,
      email,
      password
    );
    return response.data;
  }
);

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ mother_user_id, username, password }) => {
    return await AuthService.login(mother_user_id, username, password);
  }
);

export const loginOperator = createAsyncThunk(
  "auth/loginOperator",
  async ({ mother_user_id, username, password }) => {
    return await AuthService.loginOperator(mother_user_id, username, password);
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUserAndResetOrders",
  async (_, { dispatch }) => {
    TokenService.removeUser();

    await dispatch(resetAllSlices());
  }
);

export const resetAllSlices = createAsyncThunk(
  "resetAllSlices",
  async (_, { dispatch }) => {
    disconnectSocket();
    dispatch({ type: RESET });
  }
);

// Slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    refreshToken(state, action) {
      // implement refreshing token logic if needed
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isLoggedIn = false;
      })
      .addCase(registerUser.fulfilled, (state) => {
        state.loading = false;
        state.isLoggedIn = false;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.isLoggedIn = false;
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isLoggedIn = false;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.isLoggedIn = false;
      })
      .addCase(loginOperator.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isLoggedIn = false;
      })
      .addCase(loginOperator.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(loginOperator.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.isLoggedIn = false;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.isLoggedIn = false;
        removeIFoodWidget();
      })
      .addCase(RESET, () => initialState);
  },
});

export const { refreshToken } = authSlice.actions;

export default authSlice.reducer;
